// extracted by mini-css-extract-plugin
export default {"admin":"AdminPage_admin__7zlmP"};